import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { IExternalLink } from 'src/app/core/models/i-external-link';
import { IExternalLinkFormGroup } from '../../interfaces/i-external-link-form-group';
import { ILinkInsert } from 'src/app/core/dtos/interfaces/i-link-insert';
import { DataLinkType } from 'src/app/core/dtos/enums/data-link-type';

@Component({
  selector: 'app-external-links',
  templateUrl: './external-links.component.html',
  styleUrls: ['./external-links.component.scss'],
})
export class ExternalLinksComponent {
  @Input() isExpandedByDefault = false;
  @Input() isExpandable = true;
  @Input() externalLinksControl: FormArray<FormControl<IExternalLink>>;
  @Output() handleAddToBody = new EventEmitter<ILinkInsert>();
  @Output() handleRemoveLink = new EventEmitter<{
    regex: string;
    newValue: string;
  }>();
  isLinkFormVisible: boolean = false;
  isEditMode = false;
  externalLinkForm: FormGroup<IExternalLinkFormGroup>;

  initExternalLinkForm() {
    this.externalLinkForm = new FormGroup({
      text: new FormControl(null, Validators.required),
      url: new FormControl(null, [
        Validators.required,
        ExternalLinksComponent.urlValidator,
      ]),
      id: new FormControl(this.externalLinksControl.length + 1),
    });

    this.toggleLinkForm();
  }

  addExternalLink() {
    if (!this.externalLinkForm.valid) {
      return;
    }
    this.externalLinksControl.push(
      new FormControl(this.externalLinkForm.getRawValue())
    );
    this.toggleLinkForm();
  }

  onEditExternalLink(item: IExternalLink) {
    this.externalLinkForm = new FormGroup({
      text: new FormControl<string>(item.text, Validators.required),
      url: new FormControl<string>(item.url, [
        Validators.required,
        ExternalLinksComponent.urlValidator,
      ]),
      id: new FormControl<number>(item.id),
    });
    this.isEditMode = true;
    this.toggleLinkForm();
  }
  editExternalLink() {
    if (!this.externalLinkForm.valid) {
      return;
    }
    const linkToUpdate: IExternalLink = this.externalLinkForm.getRawValue();
    let indexToEdit = this.externalLinksControl.value.findIndex(
      (x) => x.id == linkToUpdate.id
    );
    this.externalLinksControl.controls[indexToEdit].patchValue({
      url: linkToUpdate.url,
      text: linkToUpdate.text,
      id: linkToUpdate.id,
    });
    this.isEditMode = false;
    this.toggleLinkForm();
  }

  onAddToBody(item: IExternalLink) {
    this.handleAddToBody.emit({
      id: item.id.toString(),
      name: item.text,
      dataLinkType: DataLinkType.EXTERNAL_LINK,
      url: item.url,
    });
  }

  onRemove(item: IExternalLink) {
    let indexToRemove = this.externalLinksControl.value.findIndex(
      (x) => x.id == item.id
    );
    if (indexToRemove > -1) {
      this.handleRemoveLink.emit({
        regex: '(<a[^>]*data-link-id="' + item.id + '"[^>]*>(.*?)</[a|A]>)',
        newValue: '$2',
      });
      this.externalLinksControl.removeAt(indexToRemove);
    }
  }

  toggleLinkForm() {
    this.isLinkFormVisible = !this.isLinkFormVisible;
  }

  private static urlValidator({
    value,
  }: AbstractControl): null | ValidationErrors {
    try {
      new URL(value);
      return null;
    } catch {
      return { pattern: true };
    }
  }
}
